import { ImageMetas } from '@/reports/types/people';

export default function imageSort(
  a: ImageMetas[number],
  b: ImageMetas[number]
) {
  if (a.source === 'googleplus' && b.source === 'gravatar') {
    return -1;
  }
  if (b.source === 'googleplus' && a.source === 'gravatar') {
    return 1;
  }
  if (a.source === 'googleplus' || a.source === 'gravatar') {
    return 1;
  }
  if (b.source === 'googleplus' || b.source === 'gravatar') {
    return -1;
  }
  if (a.source === 'linkedin' && b.source !== 'linkedin') {
    return -1;
  }
  if (b.source === 'linkedin' && a.source !== 'linkedin') {
    return 1;
  }
  if (a.source === 'facebook' && b.source !== 'facebook') {
    return -1;
  }
  if (b.source === 'facebook' && a.source !== 'facebook') {
    return 1;
  }
  if (a.source === 'twitter' && b.source !== 'twitter') {
    return -1;
  }
  if (b.source === 'twitter' && a.source !== 'twitter') {
    return 1;
  }
  if (
    a.meta?.confidence &&
    b.meta?.confidence &&
    a.meta?.confidence > b.meta?.confidence
  ) {
    return -1;
  }
  if (
    a.meta?.confidence &&
    b.meta?.confidence &&
    a.meta?.confidence < b.meta?.confidence
  ) {
    return 1;
  }
  return 1;
}
